import { Component, InjectionToken, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from "@angular/core";
import { MatStepper } from "@angular/material/stepper";
import { select, Store } from "@ngrx/store";
import { Observable, Subscription } from "rxjs";
import { RefLanguageDto } from "src/app/api/models";
import { ViewLocator } from "src/app/kiosk/kiosk.view-locator";
import { AppState } from "src/app/state/app.state";
import { getSelectedLanguage } from "../../../transaction-info/state/transaction-info.selectors";
import { getStepperIndex } from '../state/stepper.selector';
@Component({
    selector: "app-stepper",
    templateUrl: "./stepper.component.html",
    styleUrls: ["./stepper.component.scss"],
    standalone: false
})
export class StepperComponent implements OnInit,OnDestroy{
	public loadingStep = false;
	@ViewChild("stepper") private myStepper: MatStepper;
	public steps:any ; 

	public show = false;
	stepperIndex$: Observable<number> = this.store.pipe(select(getStepperIndex));
	refLanguage$: Observable<RefLanguageDto> = this.store.pipe(select(getSelectedLanguage));
	private subs: Subscription[] = [];

	constructor(private vl: ViewLocator, private store: Store<AppState>) { }
	

	ngOnInit(): void {
		this.subs.push(
			this.refLanguage$.subscribe((_) => {
				this.show = (_ !== null) ;
				this.steps = [
          { title: "STEPPER_IDENTIFICATION", state: 'number', completed: false },
          { title: "STEPPER_AGREEMENT", state: 'number', completed: false },
          { title: "STEPPER_ADMISSION_DATE_PLACE", state: 'number', completed: false },
          { title: "STEPPER_QUESTIONNAIRE", state: 'number', completed: false },
          { title: "STEPPER_LIGHT", state: 'number', completed: false }
        ];				
			})
		); 
	}

	ngAfterViewInit() {
		this.subs.push(
			this.stepperIndex$.subscribe((index) => {
				if (this.myStepper == undefined)
          return;

      this.myStepper.reset();

      for (let i = 1; i < index; i++) {
        this.myStepper.next();
      }

				if (index == 5) {
					this.myStepper.selected.editable = false;
					this.myStepper.steps.last.state = 'done';
					this.myStepper.selected.state = 'done';
				}
			})
		);
	}	

	ngOnDestroy(): void {
		this.subs.forEach((_) => _.unsubscribe());
	}
}
